export const FLOATING_BUTTON = {
  SIZE: 64,
  OFFSET: 16,
  BUTTON_DEFAULT_POSITION: {
    X: 20,
  }
};

